import TableHead from "@mui/material/TableHead";
import React from "react";

import "./styles.scss";
import { ParentProps } from "../../types";

const classNameBase = "scd-table-head";

export default function Head(props: ParentProps): React.ReactElement {
  return (
    <TableHead
      classes={{
        root: `${classNameBase}-root`,
      }}
    >
      {props.children}
    </TableHead>
  );
}
